import { config } from "../env";
import { get } from "./helpers/http-handler";

export const autoScanDocument = (queryRequest: string) =>
  get(`${config.API_URL}/autoscan?${queryRequest}`);